import { render, staticRenderFns } from "./tinymce.vue?vue&type=template&id=6f54301a&scoped=true&"
import script from "./tinymce.vue?vue&type=script&lang=js&"
export * from "./tinymce.vue?vue&type=script&lang=js&"
import style0 from "./tinymce.vue?vue&type=style&index=0&id=6f54301a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f54301a",
  null
  
)

export default component.exports